import CodeFrontEndList from "./pages/ListPage.vue";
import CodeFrontEndDetail from "./pages/FormPage.vue";
import CodeFrontEndIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_front_end",
    component: CodeFrontEndIndex,
    redirect: "/code_front_end/list",
    name: "code_front_end",
    children: [
      {
        path: "list",
        component: CodeFrontEndList,
        name: "code_front_end.list",
      },
      {
        path: "create",
        component: CodeFrontEndDetail,
        name: "code_front_end.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeFrontEndDetail,
        name: "code_front_end.edit",
        props: { create: false },
      },
    ],
  },
];
